import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import Moment from 'react-moment';
import { modePaiementMustBeTranslate,modePaiementFidelite } from 'app/modePaiementDefaultAll';
var JsBarcode = require('jsbarcode');


// Create styles
const styles = StyleSheet.create({
    logo: {
        margin:'auto',
        height:100,
        width:100,
    },
    shopName: {
        textAlign:'center',
        fontSize: 10,
    },
    infoShop:{
        textAlign:'center',
        fontSize: 10,
    },
    infoTicket:{
        textAlign:'left',
        fontSize: 10,
    },
    detailTicket:{
        textAlign:'left',
        fontSize: 10,
        marginBottom:5,
    },
    detailTaxes:{
        textAlign:'left',
        fontSize: 10,
    },
    codebar: {
        justifyContent: 'center',
        marginTop: 1,
        marginBottom:10
    }
   
  });


  // Create Document Component
  const TicketSupplement = (props) => {
    let canvas;
    // For Barcode
    canvas = document.createElement('canvas');
    JsBarcode(canvas, props.ticketPdf.bar, {
        width: 2,
        height: 65,
        displayValue: true,
        
    });
    const barcode = canvas.toDataURL();

    let logo = (props.thisShop) ? process.env.REACT_APP_API_URL+'images/'+props.thisShop.logo : false

    let textInferieur = (props.thisShop && props.thisShop.infos_inferieur_ticket!=null && props.thisShop.infos_inferieur_ticket!='') ? props.thisShop.infos_inferieur_ticket.split('\n') : []
    let digit = (props.authParam.company.advanceparams.hasOwnProperty('ventilation_espece') && props.authParam.company.advanceparams.ventilation_espece.piece.find(piece=> +piece < 1)) ? 2 : 0;

    function espace_mille(nombre){
        let numToConvert = (digit==0) ? nombre : Number(nombre).toFixed(digit)
        
        if(numToConvert<=999) return numToConvert.toString();
        if(numToConvert<=999999) return numToConvert.toString().slice(0,numToConvert.toString().length-3)+' '+numToConvert.toString().slice(-3);
        if(numToConvert<=999999999) return numToConvert.toString().slice(0,numToConvert.toString().length-6)+' '+numToConvert.toString().slice(-6,-3)+' '+numToConvert.toString().slice(-3);
    }

    let clientName = (props.ticketPdf.client!=null && props.ticketPdf.client.name!=null && props.ticketPdf.client.firstname!=null) ? props.ticketPdf.client.name+' '+props.ticketPdf.client.firstname : (props.ticketPdf.client!=null && props.ticketPdf.client.name!=null) ? props.ticketPdf.client.name : ''
    let clientMoreInfo = (props.ticketPdf.client!=null && props.ticketPdf.client.tel!=null) ? ' / '+props.ticketPdf.client.tel : ''

    const preparation_detail_parent = props.ticketPdf.ticket_detail.filter(value => ((value.combo && value.combo_parent_id==null) || !value.combo))

    // Module mode_service
    const mode_service = props.moduleParam.params.mode_service?.active
    const nbr_article = props.moduleParam.params?.ticket?.params?.nbr_article

    // Infos note globale
    var count = 0
    var countRetour = 0
    let lineCount = Object.keys(props.ticketPdf).length!= 0 ? props.ticketPdf.ticket_detail.length : 0
    Object.keys(props.ticketPdf).length!= 0 && props.ticketPdf.ticket_detail.map(item=>{
        if(item.special=='retour'){
            countRetour+=+item.quantity
        }else{
            count+=+item.quantity
        }
        
    })

//style={{ maxWidth: '70%', maxHeight: 70 }}
    return(
        <Document>
            <Page size={[215]} style={{padding:'15px'}}>
                {/* Logo part */}
                {(logo) ? 
                    <View style={styles.logo} >
                        <Image  src={logo}/>
                    </View>
                :
                    false
                }

                {/* Shop infos part */}
                {(props.thisShop && props.thisShop.infos_superieur_ticket!=null) ?
                    <View style={styles.infoShop}>
                        {props.thisShop.infos_superieur_ticket.map((value,ind)=>{
                            return(
                                <Text style={{marginBottom:2}} key={ind}>{value}</Text>
                            )
                        })}                    
                    </View>
                :
                    false
                }

                {(props.ticketPdf?.bipeur_number!==null) &&
                    <View style={styles.infoShop}>
                        <Text style={{marginBottom:6,marginTop:6,fontSize:8}}>__________________________________________</Text>
                        <Text style={{textAlign:'center',fontSize:16,textAlignVertical:'center'}}>{'BIPEUR# ' + props.ticketPdf.bipeur_number}</Text>
                    </View>
                }

                <View style={styles.infoShop}>
                    <Text style={{marginBottom:6,marginTop:6,fontSize:8}}>__________________________________________</Text>

                    <Text style={{marginBottom:1,textAlign:'left'}}>{<Moment format="DD/MM/YYYY HH:mm:ss">{props.ticketPdf.date_validation}</Moment>}</Text>
                    <Text style={{marginBottom:1,textAlign:'left'}}>{props.t('ticket')+' No : '+props.ticketPdf.bar}</Text>
                    <Text style={{marginBottom:1,textAlign:'left'}}>{(props.ticketPdf.rh!=null) ? props.t('cashier')+' : '+props.ticketPdf.rh.name+' '+props.ticketPdf.rh.firstname : false}</Text>
                    <Text style={{marginBottom:1,textAlign:'left'}}>{(props.ticketPdf.client!=null) ? props.t('customer')+' : '+clientName+clientMoreInfo : false}</Text>

                    <Text style={{marginBottom:6,marginTop:6,fontSize:8}}>__________________________________________</Text>
                </View>

                {preparation_detail_parent.map(value=>{
                    return(
                        <>
                            <View key={value.id} style={styles.detailTicket}>
                                {/* Product name part */}
                                <Text style={{textAlign:'left'}}>{(value.article!=null) ? value.quantity+'x '+value.article.name : false}</Text>
                                <Text style={{textAlign:'left'}}>{(value.special=='gift_card') ? value.quantity+'x '+props.t('giftcard')+' '+value.details.reference : false}</Text>
                                <Text style={{textAlign:'left'}}>{(value.special=='retour') ? value.quantity+'x '+value.article_retour.name : false}</Text>

                                {/* Detail price and taxes part */}
                                {(!props.giftPdf) ?
                                    <View style={{justifyContent: 'space-between',flexDirection:'row'}}>
                                        <Text>{(value.article!=null) ? value.tgc+'%' : ' '}</Text>

                                        <Text>{(value.article!=null) ? espace_mille(value.prix_remise) : (value.special=='gift_card') ? espace_mille(value.prix_remise) : (value.special=='retour') ? props.t('itemReturn') : false}</Text>
                                    </View>
                                :
                                    false
                                }

                                {/* Note part */}
                                <Text style={{textAlign:'left'}}>
                                    {
                                        (value.note != null && value.note != '' && value.ecotaxe != null && value.ecotaxe != '' && +value.ecotaxe > 0) ? props.t('dont')+' '+props.t('ecotaxe').toLowerCase()+': '+espace_mille(Math.abs(value.ecotaxe))+props.devise+'\n'+value.note.replace(/<[^>]*>/g, '')+'\n' : 
                                        (value.ecotaxe != null && value.ecotaxe != '' && +value.ecotaxe > 0) ? props.t('dont')+' '+props.t('ecotaxe').toLowerCase()+': '+espace_mille(Math.abs(value.ecotaxe))+props.devise+'\n' : 
                                        (value.note != null && value.note != '') ? value.note.replace(/<[^>]*>/g, '')+'\n' : false
                                    }
                                    {
                                        (value.to_prepare_qty>0) ? props.t('itemToPrepare')+': '+value.to_prepare_qty+'\n' : false
                                    }
                                </Text>
                            </View>
                            {props.ticketPdf.ticket_detail.filter( child => child.combo_parent_id==value.id).map(detail => { // Boucle sur les enfants
                                return (
                                    <>
                                        <View key={detail.id} style={styles.detailTicket}>
                                            {/* Product name part */}
                                            <Text style={{textAlign:'left',marginLeft: 15}}>{(detail.article!=null) ? detail.quantity+'x '+detail.article.name : false}</Text>
                                            {/* Detail price and taxes part */}
                                            {(!props.giftPdf) ?
                                                <View style={{justifyContent: 'space-between',flexDirection:'row'}}>
                                                    <Text style={{textAlign:'left',marginLeft: 15}}>{(detail.article!=null) ? detail.tgc+'%' : ' '}</Text>

                                                    <Text>{(detail.article!=null) ? espace_mille(detail.prix_remise) : (detail.special=='gift_card') ? espace_mille(detail.prix_remise) : (detail.special=='retour') ? props.t('itemReturn') : false}</Text>
                                                </View>
                                            :
                                                false
                                            }
                                        </View>
                                    </>
                                )
                            })}
                            <View style={styles.detailTicket}>
                                <Text style={{textAlign:'center',marginBottom:6,marginTop:6,fontSize:10}}>--------------</Text>
                            </View>
                        </>
                    )
                })}

                {(!props.giftPdf) ?
                    <View>
                        <View style={styles.detailTaxes}>
                            <Text style={{marginBottom:6,marginTop:6,fontSize:8}}>__________________________________________</Text>

                            <View style={{flexDirection:'row',justifyContent:'space-between',marginBottom:3}}>
                                <Text>Total TTC : </Text>
                                <Text>{espace_mille(props.totalAchat)+props.devise}</Text>
                            </View>
                        </View>

                        <View style={styles.detailTaxes}>
                            <Text style={{marginBottom:6,marginTop:6,fontSize:8}}>Taxes ____________________________________</Text>
                            {(Object.keys(props.tgcForTicketPdf).length!=0) ? 
                                Object.entries(props.tgcForTicketPdf).map(([tgcName,tgcAmount])=>(
                                    <View key={tgcName} style={{flexDirection:'row',justifyContent:'space-between',marginBottom:3}}>
                                        <Text>{props.authParam.company.nomenclature_tgc+' '+tgcName+'%'+' :' }</Text>
                                        <Text>{espace_mille(tgcAmount)+props.devise}</Text>
                                    </View>
                                ))
                            :
                                false
                            }
                            <View style={{flexDirection:'row',justifyContent:'space-between',marginBottom:3}}>
                                <Text>{'Total '+props.authParam.company.nomenclature_tgc+' :'}</Text>
                                <Text>{espace_mille(props.tgcTotal)+props.devise}</Text>
                            </View>
                        </View>

                        <View style={styles.detailTaxes}>
                            <Text style={{marginBottom:6,marginTop:6,fontSize:8}}>Reglement ________________________________</Text>

                            {/* Lignes concernant les remboursements */}
                            {props.ticketPdf.remboursement_records.map(value=>{
                                return(
                                    <View>
                                        <View key={value.id} style={{flexDirection:'row',marginBottom:3,justifyContent:'space-between'}}>
                                            <Text>{(value.mode=='espece') ? props.t('refundEspece') : props.t('refundOther')}</Text>
                                            <Text style={{textAlign:'right'}}>{espace_mille(value.montant)+props.devise}</Text>
                                        </View>
                                        {(value.mode=='autre') ?<View style={{flexDirection: 'column'}}><Text style={{fontSize:'8'}}>{value.note}</Text></View>:false}
                                    </View>
                                    )
                            })}

                            {props.ticketPdf.paiement_records.map(value=>{
                                if(props.t(value.mode)){
                                    if(props.t(value.mode).length<25){
                                        return(
                                        <View key={value.id}>
                                            <View key={value.id} style={{flexDirection:'row',marginBottom:3,justifyContent:'space-between'}}>
                                                <Text>{modePaiementFidelite.includes(value.mode) ? props.t('loyalty') : (modePaiementMustBeTranslate.includes(value.mode)) ? props.t(value.mode) : value.mode}</Text>
                                                <Text>{espace_mille(value.montant)+props.devise}</Text>
                                            </View>
                                            {(value.mode=='espece' && +value.rendu!=0) ? 
                                                <View style={{textAlign:'right',fontSize:7}}>
                                                    <Text>{props.t('deposited')+' : '+espace_mille(value.verse)+props.devise}</Text>
                                                    <Text>{props.t('changeBack')+' : '+espace_mille(value.rendu)+props.devise}</Text>
                                                </View> 
                                            : <Text></Text>}
                                        </View>)
                                    }else{
                                        return(
                                        <View key={value.id}>
                                            <Text>{modePaiementFidelite.includes(value.mode) ? props.t('loyalty') : (modePaiementMustBeTranslate.includes(value.mode)) ? props.t(value.mode) : value.mode}</Text>
                                            <Text style={{textAlign:'right'}}>{espace_mille(value.montant)+props.devise}</Text>
                                        </View>)
                                    }
                                }
                                else{
                                    if(value.mode.length<25){
                                        return(
                                        <View key={value.id} style={{flexDirection:'row',marginBottom:3,justifyContent:'space-between'}}>
                                            <Text>{value.mode}</Text>
                                            <Text>{espace_mille(value.montant)+props.devise}</Text>
                                        </View>)
                                    }else{
                                        return(
                                        <View key={value.id}>
                                            <Text>{value.mode}</Text>
                                            <Text style={{textAlign:'right'}}>{espace_mille(value.montant)+props.devise}</Text>
                                        </View>)
                                    }
                                }
                            })}
                        </View>
                        {(props.moduleParam.params.fidelite.active) &&
                            <View style={styles.detailTaxes}>
                                <Text style={{marginBottom:6,marginTop:6,fontSize:8}}>Fidelite _________________________________</Text>

                                <View style={{flexDirection:'row',marginBottom:3,justifyContent:'space-between'}}>
                                    <Text>{props.t('onReceipt')+' :'}</Text>
                                    <Text>{(props.pointsFidelite.mode=='cashback') ? espace_mille(+props.pointsFidelite.cashbackAcquis)+props.devise : espace_mille(+props.pointsFidelite.acquis)+'Pts'}</Text>
                                </View>

                                <View style={{flexDirection:'row',marginBottom:3,justifyContent:'space-between'}}>
                                    <Text>Total :</Text>
                                    <Text>{(props.pointsFidelite.mode=='cashback') ? espace_mille(+props.pointsFidelite.cashbackTotal)+props.devise : espace_mille(+props.pointsFidelite.total)+'Pts'}</Text>
                                </View>

                            </View>
                        }
                    </View>
                :
                    false
                }

                {(props.ticketPdf.note!=null || mode_service || nbr_article) ?
                    <View style={styles.detailTaxes}>
                        <Text style={{marginBottom:6,marginTop:6,fontSize:8}}>Note _____________________________________</Text>

                        {props.ticketPdf.note!=null && <Text style={{textAlign:'left',marginBottom:6}}>{props.ticketPdf.note.replace(/<[^>]*>/g, '')}</Text>}
                        {nbr_article &&
                            <>
                                <Text style={{textAlign:'left',marginBottom:6}}>{('Nbr ' + props.t('items') + ': ' + Math.round(count*100)/100).replace(/<[^>]*>/g, '')}</Text>
                                <Text style={{textAlign:'left',marginBottom:6}}>{('Nbr ' + props.t('itemReturn') + ': ' + Math.round(countRetour*100)/100).replace(/<[^>]*>/g, '')}</Text>
                                <Text style={{textAlign:'left',marginBottom:6}}>{('Nbr ' + props.t('lines') + ': ' + lineCount).replace(/<[^>]*>/g, '')}</Text>
                            </>
                        }
                        {mode_service && <Text style={{textAlign:'left',marginBottom:6}}>{((props.ticketPdf.mode_service)?props.t('takeout'):props.t('eatin')).replace(/<[^>]*>/g, '')}</Text>}
                    </View>
                :
                    false
                }

                <View style={styles.detailTaxes}>
                    <Text style={{marginBottom:6,marginTop:6,fontSize:8}}>__________________________________________</Text>

                    {textInferieur.length!=0 &&
                        <View style={{textAlign:'center',marginBottom:6}}>
                            {textInferieur.map((value,ind)=>{
                                if(value!=''){
                                    return(
                                        <Text key={ind}>{value}</Text>
                                    ) 
                                }else{
                                    return(
                                        <Text key={ind} style={{marginBottom:3}}></Text>
                                    )
                                }
                            })}
                        </View>
                    }
                    
                    <Text style={{textAlign:'center'}}>{(props.thisShop && props.thisShop.name!=null) ? props.thisShop.name : false}</Text>
                    <Text style={{textAlign:'center',marginBottom:6}}>{props.t('messageEndReceipt')}</Text>

                    <Image style={styles.codebar} src={barcode}/>

                </View>
                
            </Page>
        </Document>
    )
    };

export default TicketSupplement;